module.exports = __webpack_public_path__ + "assets/7158790a6f652c1bdf9c4d0e7bb924cf.png";